import { render, staticRenderFns } from "./CoozzyReplyIcon.vue?vue&type=template&id=3d2a4b61&scoped=true"
import script from "./CoozzyReplyIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyReplyIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyReplyIcon.vue?vue&type=style&index=0&id=3d2a4b61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2a4b61",
  null
  
)

export default component.exports